// Simple in-memory API cache with TTL
const cache = new Map();
const DEFAULT_TTL = 60000; // 1 minute

export function getCached(key) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expires) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function setCache(key, data, ttl = DEFAULT_TTL) {
  cache.set(key, { data, expires: Date.now() + ttl });
}

export function clearCache(keyPrefix) {
  if (!keyPrefix) { cache.clear(); return; }
  for (const key of cache.keys()) {
    if (key.startsWith(keyPrefix)) cache.delete(key);
  }
}

// Cached fetch helper
export async function cachedGet(url, headers = {}, ttl = DEFAULT_TTL) {
  const cached = getCached(url);
  if (cached) return cached;
  const { default: axios } = await import('axios');
  const res = await axios.get(url, { headers, withCredentials: true });
  setCache(url, res.data, ttl);
  return res.data;
}
